// Single source of truth for sidebar navigation, permission gates, and page titles.
// `icon` values are keys into ICONS in ./icons.js.

export const PRIMARY_NAV = [
  { path: '/dashboard', label: 'Dashboard', icon: 'dashboard' },
  { path: '/my-submissions', label: 'My Submissions', icon: 'submissions' },
  { path: '/individual-submissions', label: 'Individual Submissions', icon: 'individual', permission: 'can_view_individual_submissions' },
];

export const ADMIN_NAV = {
  path: '/admin',
  label: 'Admin Panel',
  icon: 'admin',
  permission: 'can_access_admin_panel',
  groups: [
    {
      group: 'Users & Access',
      items: [
        { path: '/admin/registrations', label: 'Pending Registrations' },
        { path: '/admin/users', label: 'User Management' },
        { path: '/admin/admin-management', label: 'Admin Management', role: 'Admin' },
        { path: '/admin/roles', label: 'Roles & Permissions', permission: 'can_manage_roles' },
        { path: '/admin/supervisors', label: 'Supervisor Assignments', permission: 'can_assign_supervisees' },
      ],
    },
    {
      group: 'KPI Config',
      items: [
        { path: '/admin/kpi-systems', label: 'KPI Systems' },
        { path: '/admin/kpi-assignments', label: 'KPI Assignments' },
        { path: '/admin/kpi-library', label: 'KPI Library' },
      ],
    },
    {
      group: 'Stats & Reports',
      items: [
        { path: '/admin/pi-systems', label: 'PI Systems' },
        { path: '/admin/pi-assignments', label: 'PI Assignments' },
        { path: '/admin/report-systems', label: 'Report Systems' },
        { path: '/admin/report-assignments', label: 'Report Assignments' },
      ],
    },
  ],
};

// Visibility predicate used in place of the usePermission hook (so it can run in a loop).
export function canSee(entry, userRole) {
  if (!userRole) return false;
  if (entry.permission && !(userRole.permissions || []).includes(entry.permission)) return false;
  if (entry.role && userRole.role !== entry.role) return false;
  return true;
}

// The first admin sub-route the user may access (used for the /admin index redirect).
export function firstPermittedAdminPath(userRole) {
  for (const g of ADMIN_NAV.groups) {
    for (const item of g.items) {
      if (canSee(item, userRole)) return item.path;
    }
  }
  return '/admin';
}

// Flat path -> label map for the TopBar title.
const TITLES = [
  ...PRIMARY_NAV.map((i) => ({ path: i.path, label: i.label })),
  { path: ADMIN_NAV.path, label: ADMIN_NAV.label },
  ...ADMIN_NAV.groups.flatMap((g) => g.items.map((i) => ({ path: i.path, label: i.label }))),
];

export function titleForPath(pathname) {
  const exact = TITLES.find((t) => t.path === pathname);
  if (exact) return exact.label;
  const prefixed = TITLES
    .filter((t) => pathname.startsWith(t.path))
    .sort((a, b) => b.path.length - a.path.length)[0];
  return prefixed ? prefixed.label : '';
}

export function isAdminPath(pathname) {
  return pathname.startsWith('/admin');
}
